import { Type } from "class-transformer";

export class EnaioProjectDocument {
    //netgen start
    id = 0;
    objectType: string;
    type: string;
    title: string;
    documentNumber: string;
    @Type(() => Date)
    date: Date;
    //netgen end
}
